import { GET_SUMMARY_REPORT_BY_RESIDENT_SUCCESS, GET_SUMMARY_REPORT_BY_RESIDENT_FAILURE } from '../constants/MTag';
import { onSuccess, onFailure } from './common';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case GET_SUMMARY_REPORT_BY_RESIDENT_SUCCESS:
			return onSuccess(state, action);
		case GET_SUMMARY_REPORT_BY_RESIDENT_FAILURE:
			return onFailure(state, action);
		default:
			return { ...state };
	}
};
